import {
  HttpErrorHandlerService,
  MessageType,
} from './../../shared-resources/services/http-error-handling.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ForgotPasswod } from '../interfaces/forgot-pass.interface';
import { ForgotPassService } from '../services/forgot-password';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less'],
})
export class ForgotPasswordComponent implements OnInit {
  public validateForm: FormGroup;
  public loading: boolean;
  public isUserAdmin = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private forgotpassService: ForgotPassService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService
  ) {}
  signin(): void {
    this.router.navigateByUrl('/login');
  }
  signup(): void {
    this.router.navigateByUrl('/signup');
  }
  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }

  forgotPassword(): void {
    this.loading = true;
    if (this.validateForm.valid) {
      const forgotRequest: ForgotPasswod = {
        username: this.validateForm.controls['userName'].value,
      };

      this.forgotpassService.forgotRequest(forgotRequest).subscribe(
        () => {
          this.httpMessage.showTopFloatMessage(
            this.translate.instant('app.forgotpassword.request.description'),
            MessageType.SUCCESS,
            this.translate.instant('app.forgotpassword.request.success')
          );
          this.loading = false;
          this.validateForm.reset();
        },
        (error: any) => {
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.forgotpassword.request.failed')
          );
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }
  ngOnInit(): void {
    if (
      window.location.href.indexOf('/admin-ui') >= 0 ||
      window.location.href.indexOf('/studio') >= 0 ||
      window.location.href.indexOf('/intelligencesuite-ui') >= 0 ||
      window.location.href.indexOf('/inventory-ui')
    ) {
      this.isUserAdmin = true;
    }
    this.validateForm = this.fb.group({
      userName: [null, [Validators.required]],
    });
  }
}
